import { createTheme } from "@mui/material"
export const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#3a7bd5',
        },
        secondary: {
            main: '#00d2ff',
        },
        background: {
            default: '#fdfaf6',
            paper: '#fcfcfc',
        },
        text: {
          primary: '#212121', // Dark grey for primary text
          secondary: '#616161',// Medium grey for secondary text
        },
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
          ].join(','),
          h1: {
            fontSize: '3.5rem',
            fontWeight: 700,
            lineHeight: 1.2,
            '@media (min-width:600px)': {
              fontSize: '4.5rem',
            },
            '@media (min-width:900px)': {
              fontSize: '5.5rem',
            },
          },
          h2: {
            fontSize: '2.5rem',
            fontWeight: 700,
            '@media (min-width:600px)': {
              fontSize: '3.5rem',
            },
          },
          h3: {
            fontSize: '2.2rem',
            fontWeight: 650,
          },
          h4: {
            fontSize: '1.8rem',
            fontWeight: 600,
          },
          h5: {
            fontSize: '1.5rem',
            fontWeight: 580,
          },
        h6: { fontWeight: 200, color:'#2b394a', fontSize: '2rem' },
        body1: { fontSize: '1.1rem', color:"black", lineHeight: 1.6 },
    },
    components: {
        Section:{
            textcolor:'#b0bec5'
        },
        MuiContainer:{
            maxWidth: false,
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: 'Barlow',
                    fontWeight: '600',
                    fontSize: '13px',
                    borderRadius: '30px',
                    color:'#131310',
                    padding: '10px 20px',
                    background: '#ededf7'
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                root: {
                    fontFamily: 'Barlow',
                    fontWeight: '600',
                    fontSize: '13px',
                    color:'#131310',
                    background: 'rgba(237,237,247,0.7)'
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& label.Mui-focused': {
                        color: 'black',
                    },
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '15px',
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'black', // Default border color
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'black', // Hover border color
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'black', // Focused border color
                        },
                        borderColor: '#fda5a4'
                    },
                },
            },
        },
    },
});